import assets from 'modules/assets'

export function intro(data) {
  return {
    content: [
      [
        {
          type: 'h3',
          content: ['Kohai']
        },
        {
          type: 'ol',
          definition: 'noun.',
          style: ['medium-large', 'two-thirds', 'no-min-height'],
          content: ['People who were born after you.', 'The high school students who attend camp, in search of "something more"']
        }
      ],
      [
        {
          type: 'p',
          content: ['Gakko Camps are created by passionate and caring college students, graduate school students, and young professionals from around the globe. Despite their diverse backgrounds, the sempai unite with a mission to build from scratch a truly transformational summer camp for high schoolers.']
        }
      ],
      [
        {
          type: 'p',
          content: ['In the past, our sempai have represented academic institutions such as Harvard, NYU, Oxford, Yale, Stanford, Princeton, Reed, UCL, Sciences Po, U Penn, and more. They reflect on their own high school experience, and ask themselves: what could we teach if we were high school teachers for two weeks? Our goal is to create an experience for high school students to realize how empowering learning can be in college and beyond. At each camp, we are gathering a group of 40 curious, driven, empathic high school students to join us on a journey to question learning.']
        },
        {
          type: 'h5',
          content: 'Kohai applications for 2018 will open in January 2018.'
          //outbound: true,
          //linkURL: 'https://jobs.lever.co/gakkoproject/38df5eed-8659-441a-b040-9ac172f9c0eb/apply'
        }
      ]
    ]
  }
}

export function campExample(data) {
  return {
    title: {
      content: [
        [
          {
            type: 'h3',
            content: ['Example Camp:', 'Romania 2016']
          }
        ],
        [
          {
            type: 'p',
            content: ['Each Gakko Camp is unique: there is no set formula or curriculum, and every group of sempai gets the opportunity to build their camp from the ground up. Beyond individual workshops and activities, the camps are designed as holistic experiences, with daily rhythms and a larger thematic "flow" considered from the start.']
          }
        ],
        [
          {
            type: 'p',
            content: ['In 2016, the Romanian team built their camp on the structure of Joseph Campbell\'s "Hero\'s Journey". Each day was given a question, and the camp was divided into two halves: in the first, kohai were introduced to new ideas and skills; in the second, the roles were reversed and the kohai were tasked with their own acts of creation and education.']
          }
        ]
      ]
    },
    content: [
    ],
    contentLarge: [
      {
        date: 'Day One',
        content: [
          {
            title: {
              content: 'Arrival',
              style: {
                size: 'small'
              }
            },
            subTitle: {
              content: 'Introductions & hellos.',
              style: {
                bold: false
              }
            }
          },
          {
            title: { content: '' },
            subTitle: {
              content: 'Family groups.',
              style: {
                bold: false
              }
            }
          }
        ]
      },
      {
        date: 'Day Two',
        content: [
          {
            title: {
              content: 'What is this?',
              style: {
                size: 'small'
              }
            },
            subTitle: {
              content: 'Rules & Values forum.',
              style: {
                bold: false
              }
            }
          },
          {
            title: { content: '' },
            subTitle: {
              content: 'Workshop: Untitled (Anthropology).',
              style: {
                bold: false,
                emphasis: true
              }
            }
          },
          {
            title: { content: '' },
            subTitle: {
              content: 'Workshop: Design 101',
              style: {
                bold: false,
                emphasis: true
              }
            }
          }
        ]
      },
      {
        date: 'Day Three',
        content: [
          {
            title: {
              content: 'Who are we?',
              style: {
                size: 'small'
              }
            },
            subTitle: {
              content: 'Workshop: Maps. Maps? Maps!',
              style: {
                bold: false,
                emphasis: true
              }
            }
          },
          {
            title: { content: '' },
            subTitle: {
              content: 'Ethics of Photography.',
              style: {
                bold: false
              }
            }
          },
          {
            title: { content: '' },
            subTitle: {
              content: 'Beach Trip!',
              style: {
                bold: false
              }
            }
          }
        ]
      },
      {
        date: 'Day Four',
        content: [
          {
            title: {
              content: 'Who are these people?',
              style: {
                size: 'small'
              }
            },
            subTitle: {
              content: 'Workshop: Gestures (Dance).',
              style: {
                bold: false,
                emphasis: true
              }
            }
          },
          {
            title: { content: '' },
            subTitle: {
              content: 'Workshop: Museum of Now (History).',
              style: {
                bold: false,
                emphasis: true
              }
            }
          },
          {
            title: { content: '' },
            subTitle: {
              content: 'Workshop: Surround Sound (Music)',
              style: {
                bold: false,
                emphasis: true
              }
            }
          }
        ]
      },
      {
        date: 'Day Five',
        content: [
          {
            title: {
              content: 'What\'s new',
              style: {
                size: 'small'
              }
            },
            subTitle: {
              content: 'Workshop: Making/Breaking Codes.',
              style: {
                bold: false,
                emphasis: true
              }
            }
          },
          {
            title: { content: '' },
            subTitle: {
              content: 'Discussion: Whiter Music?',
              style: {
                bold: false,
                emphasis: true
              }
            }
          },
          {
            title: { content: '' },
            subTitle: {
              content: 'Workshop: Earth Art.',
              style: {
                bold: false,
                emphasis: true
              }
            }
          },
          {
            title: { content: '' },
            subTitle: {
              content: 'Stargazing at the beach!',
              style: {
                bold: false
              }
            }
          }
        ]
      },
      {
        date: 'Day Six',
        content: [
          {
            title: {
              content: 'Who am I?',
              style: {
                size: 'small'
              }
            },
            subTitle: {
              content: 'Sleep in!',
              style: {
                bold: false
              }
            }
          },
          {
            title: { content: '' },
            subTitle: {
              content: 'Kohai workshops prep.',
              style: {
                bold: false
              }
            }
          },
          {
            title: {content: ''},
            subTitle: {
              content: 'Deep-dives: Sempai Q&A',
              style: {
                bold: false,
                emphasis: true
              }
            }
          }
        ]
      },
      {
        date: 'Day Seven',
        content: [
          {
            title: {
              content: 'Field Trip!',
              style: {
                size: 'small'
              }
            },
            subTitle: {
              content: 'A day on the Danube!',
              style: {
                bold: false
              }
            }
          }
        ]
      },
      {
        date: 'Day Eight',
        content: [
          {
            title: {
              content: 'What is my worldview?',
              style: {
                size: 'small'
              }
            },
            subTitle: {
              content: 'Workshop: Surround Sound #2.',
              style: {
                bold: false,
                emphasis: true
              }
            }
          },
          {
            title: {content: ''},
            subTitle: {
              content: 'Workshop: Politics as Theater.',
              style: {
                bold: false,
                emphasis: true
              }
            }
          },
          {
            title: {content: ''},
            subTitle: {
              content: 'Workshop: Museum of Now #2',
              style: {
                bold: false,
                emphasis: true
              }
            }
          }
        ]
      },
      {
        date: 'Day Nine',
        content: [
          {
            title: {
              content: 'What can I do?',
              style: {
                size: 'small'
              }
            },
            subTitle: {
              content: 'Workshop: Surreal Art.',
              style: {
                bold: false,
                emphasis: true
              }
            }
          },
          {
            title: {content: ''},
            subTitle: {
              content: 'Presentations: Surround Sound.',
              style: {
                bold: false,
                emphasis: true
              }
            }
          },
          {
            title: {content: ''},
            subTitle: {
              content: 'Talent show + movie night!',
              style: {
                bold: false
              }
            }
          }
        ]
      },
      {
        date: 'Day Ten',
        content: [
          {
            title: {
              content: 'What did we do?',
              style: {
                size: 'small'
              }
            },
            subTitle: {
              content: 'Kohai workshops prep time.',
              style: {
                bold: false
              }
            }
          },
          {
            title: {content: ''},
            subTitle: {
              content: 'Presentations: Kohai Workshops.',
              style: {
                bold: false,
                emphasis: true
              }
            }
          },
          {
            title: {content: ''},
            subTitle: {
              content: 'Scavenger Hunt!',
              style: {
                bold: false
              }
            }
          }
        ]
      },
      {
        date: 'Day Eleven',
        content: [
          {
            title: {
              content: 'What do we carry home?',
              style: {
                size: 'small'
              }
            },
            subTitle: {
              content: 'Beach trip!',
              style: {
                bold: false
              }
            }
          },
          {
            title: {content: ''},
            subTitle: {
              content: 'String exchange + letters.',
              style: {
                bold: false
              }
            }
          },
          {
            title: {content: ''},
            subTitle: {
              content: 'Presentations: Self-portraits.',
              style: {
                bold: false,
                emphasis: true
              }
            }
          },
          {
            title: {content: ''},
            subTitle: {
              content: 'Campfire at the beach!',
              style: {
                bold: false
              }
            }
          }
        ]
      },
      {
        date: 'Day Twelve',
        content: [
          {
            title:  {
              content: 'Something more',
              style: {
                size: 'small'
              }
            },
            subTitle: {
              content: 'Goodbyes. The long boat ride home.',
              style: {
                bold: false
              }
            }
          }
        ]
      }
    ]
  }
}

export function workshopExample(data) {
  return {
    content: [
      [
        {
          type: 'h3',
          content: ['Example Workshop', 'Maps. Maps? Maps!']
        }
      ],
      [
        {
          type: 'p',
          content: ['A collaboration between a mathematics student, a computer science/art major, and a graphic designer (Jack, Ash, and Michael) led to this interactive workshop on the art and design of mapmaking.']
        }
      ],
      [
        {
          type: 'p',
          content: ['Kohai grappled with the question of how to project a three-dimensional object like the earth onto the two-dimensional plane of a map, learned about the “signal-noise ratio” in information design, and questioned the societal impacts of maps and the distortions and omissions required in their creation.']
        }
      ]
    ]
  }
}

export function kohaiExperience(data) {
  return {
    sectionTitle: 'The Kohai Experience',
    content: [
      [
        {
          type: 'h3',
          content: ['', 'Interdisciplinary Workshops, Experiential Learning']
        },
        {
          type: 'p',
          content: ['At Gakko, the diversity of our pursuits, interests, disciplines, investigations are our bread and butter. In preparing for our programs, we expend utmost care and time on seeking out young people with a deep curiosity about and strong commitment to their respective fields. The team of 8-10 sempai that you will be working with will cover a truly interdisciplinary range, and work together to dissolve the boundaries between the usual categories. We believe that communication breeds creativity. What does a cryptographer have to learn from a performance artist, a psychologist of perception from an architect?']
        },
        {
          type: 'p',
          content: [' Prior to the camp, the sempai spend weeks working together, genuinely questioning how to best communicate and share their pursuits through experiential workshops, hands-on projects, and thoughtful discussions. Students come to Gakko seeking an opportunity to be exposed to disciplines, ways of working and thinking that they may not be exposed to in their everyday education, and to find support in discovering and pursuing their own interests.']
        }
      ],
      [
        {
          type: 'h3',
          content: ['', 'Participatory Community, Personalized Mentorship']
        },
        {
          type: 'p',
          content: ['The Gakko experience is not reducible to the sum of workshops or projects we do: it is a two-week experiment in building communities. The small size of our group of 10 sempai and 40 kohai allows us to foster an intimate network of personalized mentorship. At camp, each sempai is paired with five kohai to form a family group, a structure that enables intimate and personal mentor-mentee relationship. From applying to colleges to choosing their majors, studying abroad to taking a gap year, sempai share their experiences through relatable perspectives to help kohai navigate through the many choices they have to make as young adults.']
        },
        {
          type: 'p',
          content: ['We are also committed to building a caring community at the camp scale and beyond, together asking: what can we make of this experience? What are our shared values and principles? How do we hold ourselves and each other accountable to the values we seek to uphold? We build an environment of mutuality from the ground up, where each participant, whatever their role may be, takes ownership over their own personal growth, as well as the maintenance of a healthy and supportive community.']
        }
      ],
      [
        {
          type: 'h3',
          content: ['', 'Global presence, Thriving in Diversity.']
        },
        {
          type: 'p',
          content: ['Living in an age of rapid globalization, we sorely feel the need to expose ourselves to different perspectives and grow as nimble global citizens. In the past, the sempai and kohai at Gakko Camps have hailed from more than 37 different countries, and we continue to expand and diversify our global outreach. The kohai at Gakko get to learn about places and cultures other than their own by making friends across geographical, national, socio-economic barriers. Our belief in equal access to quality learning environments takes us to increasingly more parts of the world as our team organically grows. Taking active part in a truly diverse community committed to be thoughtful leaders for the 21st century, we seek to increase our impact at home and abroad.']
        }
      ]
    ]
  }
}

export function financial(data) {
  // Feeds into RowThreeText
  return {
    sectionTitle: 'Pricing',
    content: [
      [
        {
          type: 'h3',
          content: ['', 'Cost: $2,880']
        },
        {
          type: 'p',
          content: 'This cost includes accommodation, food, materials used in the program, transportation during the camp. Also, each camp will schedule a pick up from the closest airport or a major station (Paris, Bali, Tokyo, and Bucharest) on the respective start dates, which will be included in the cost. The pick-up location for each camp will be announced after kohai have been accepted to the program. Please note that transportation to Paris, Bali, Tokyo, or Bucharest will not be covered by Gakko. During the camp, a camp nurse or doctor will be on the premises at all times, as will several adult employees of Gakko.'
        }
      ],
      [
        {
          type: 'h3',
          content: ['', 'Financial Aid']
        },
        {
          type: 'p',
          content: 'Gakko is committed to including students from a variety of backgrounds, and we want to make sure that all curious, engaged students can take part in our programs. We offer need-based financial aid, which means that we will provide scholarships as a one-time gift, in whole or in part, to students in need. Applicants are asked to indicate their approximate projected need for financial assistance in the application form which will be taken into consideration in the selection process. As a reference, last year we granted a total of $94,400 to 59% of participating kohai. The average total household income for those granted financial aid was $22,962.'
        }
      ],
      [
        {
          type: 'h3',
          content: ['', '']
        },
        {
          type: 'p',
          content: 'Upon acceptance, we will ask that you submit your guardians’ tax returns and income statements to finalize the amount of scholarship to be granted. Our licensed accountant will review the documents, and all of them will be held in strict confidence. We recommend you to start collecting the documents required for our financial aid application when you receive your interview request as it may take a while to prepare.'
        }
      ]
    ]
  }
}

export function faq(data) {
  return {
    title: 'FAQ',
    subTitle: '',
    english: 'Kohai —',
    japanese: '後輩',
    definition: '/\'kohai/',
    wordType: 'noun',
    definition2: 'people who were born after you',
    definition3: 'Gakko camp participants',
    button: 'Apply to be a kohai',
    linkURL: 'https://jobs.lever.co/gakkoproject/1608594c-4e3a-48fc-a7a0-b8691aca961e/apply',
    deadline: 'Deadline: March 2nd 2017',
    questions: [
      {
        question: 'Who can apply?',
        answer: 'The camp is open to all high school students. Since the camp is conducted entirely in English, we ask that all applicants have basic English abilities, but even if you’re not confident in your English, we’d love for you to send us an application.'
      },
      {
        question: 'Can I apply to several camps?',
        answer: 'We have a joint application for all four camps where you can indicate all the camps you can attend, however, in case of acceptance, you will be placed into one camp. If you check more than one camp, you will be able to indicate your preference and explain your reasons. You are more than welcome to come back to the camp at a different locations in the following years.'
      },
      {
        question: 'What kind of applicant are you looking for?',
        answer: 'This is hard to answer, because Gakko doesn’t look for any "type" of kohai. Our campers are all people we think we’d like to be friends with and grow from. They come from a wide set of backgrounds and cultivate a variety of interests, but they all have at least one thing in common: a passion and drive to keep learning and growing. You can watch our videos to get a better sense of what camp is like. If you want to know more, email us at hello@gakkoproject.com and we can put you in touch with past participants in your area. I’m sure they would love to talk to you about their experiences at Gakko Camps!'
      },
      {
        question: 'Can you accommodate students with severe disabilities, severe allergies, dietary restrictions or other special needs?',
        answer: 'Although we try to create an environment that welcomes people with various physical conditions, this has to be answered in a case-by-case manner. Please contact us at hello@gakkoproject.com and we can set up a call to discuss your situation with our camp directors.'
      },
      {
        question: 'What should I expect from the interview?',
        answer: 'Most often, the interview will be a video chat or phone call with a sempai or director from the Gakko team, and should last about half an hour. Interviews will be conducted in English. No need to prepare—we just want you to be yourself!'
      },
      {
        question: 'Do I need to provide a transcript or reference letter?',
        answer: 'We do not require transcripts, but we ask that you provide the name and contact information of one teacher or mentor that we can reach out to for a reference letter. This person could be a current or past teacher or administrator from your school, or another adult who has served as a mentor or instructor to you. They should be someone you have worked with closely, who can attest to your personality, work habits and interests. Please make sure that you ask for this person’s permission before listing them on your application, and communicate to them that the Gakko team might contact them in the next few months to gain more insight about you.'
      },
      {
        question: 'I want to apply for financial aid. What if my parents haven’t finished their tax returns?',
        answer: 'We ask your guarding for either the 2015 fiscal year returns, an equivalent document, or an estimate. If such documents are not available in your country or city, please contact us directly and we can discuss alternative options.'
      },
      {
        question: 'If I apply for financial aid, will my chances of getting in be affected?',
        answer: 'Yes, the more scholarship you request, the more competitive the selection becomes. However, we work as we can throughout the year to fundraise to provide as much financial aid as possible. As a reference, last year, we provided the total of $94,400 financial aid to 59% of participating kohai, and the average household income for scholarship recipients was $22,962.'
      },
      {
        question: 'Will financial aid cover my travel expenses?',
        answer: 'In most cases, we do not cover your travel expenses to/from the camp. This is firstly because of liability issues, and secondly our desire to provide financial aids to students who live close to respective camp venues. However, we have made exceptions in the past for exceptional candidates and have provided travel aid for them to participate in our programs. If you do end up receiving financial aid, we do ask you to participate in the closest camp from your location.'
      },
      {
        question: 'Can you help with my travel and visa arrangements?',
        answer: 'Unfortunately not. For liability purpose, we cannot handle your travel bookings and visa application process. We do have assistive documents we have provided to past kohai with to help with their visa application process. Please start your travel arrangements and visa applications as soon as you’re accepted into the program, and let us know if you need any supportive documents from us.'
      },
      {
        question: 'I have a question that\'s not answered here. Who do I contact?',
        answer: 'Please email us at hello@gakkoproject.com with any other questions. We look forward to hearing from you!'
      }
    ]
  }
}

export function location(data) {
  return {
    title: {
      type: 'h2',
      content: ['Gakko 2017']
    },
    content: [
      {
        imageURL: assets('images/locations/france.jpg'),
        title: 'Burgundy, France',
        subTitle: 'July 9-22',
        description: 'An hour outide of Paris, Château de Fëy is a splendid 17th century property classified `monument historique`. The property stands on 100 acres overlooking the Yonne river with superb views over the countryside.'
      },
      {
        imageURL: assets('images/locations/romania.jpg'),
        title: 'Danube Delta, Romania',
        subTitle: 'July 9-22',
        description: 'Our love of nature and exploration will also take us to the enchanted corners of the Danube Delta, a UNESCO World Heritage Site. In a sanctuary teeming with life and insights waiting to take shape, sempai and kohai will spend the day together in critical thought and childlike wonder.'
      },
      {
        imageURL: assets('images/locations/japan.jpg'),
        title: 'Chiba, Japan',
        subTitle: 'August 5-18',
        description: 'We return to Forest Village to build—amid the trees of Chiba—spaces for introspection, self-expression, connection, and reflection. The site offers the combination of a refreshing beautiful forest, a century-old national park, and a charming brick lodge.'
      },
      {
        imageURL: assets('images/locations/bali.jpg'),
        title: 'Bali, Indonesia',
        subTitle: 'August 5-18',
        description: 'Surrounded by pristine rainforests and magical beaches, Green School in Ubud Village on the Bali island is a growing hub for social innovation. In close collaboration with the Green School, we hope to contribute to a diverse local community that shares our vision of a better education for all.'
      }
    ]
  }
}

export function wasAKohai(data) {
  // Feeds into RowThreeBlock
  return {
    title: '\"I Was a Kohai\"',
    content: [
      {
        linkURL: 'https://vimeo.com/159180624',
        style: 'grid-small spotlight-link',
        title: 'I Was a Kohai - Kojin Oshiba',
        subTitle: 'Learn more',
        firstRow: {
          type: 'img',
          imageURL: assets('images/kohai/Kojin.jpg'),
          style: ''
        }
      },
      {
        linkURL: ' https://vimeo.com/160836096',
        style: 'grid-small grid-middle spotlight-link',
        title: 'I Was a Kohai - Yuki Hayashi',
        subTitle: 'Learn more',
        firstRow: {
          type: 'img',
          imageURL: assets('images/kohai/Yuki.jpg'),
          style: ''
        }
      },
      {
        linkURL: 'https://vimeo.com/156517062',
        style: 'grid-small spotlight-link',
        title: 'I Was a Kohai - Makoto Shinzo',
        subTitle: 'Learn more',
        firstRow: {
          type: 'img',
          imageURL: assets('images/kohai/Makoto.jpg'),
          style: ''
        }
      }
    ]
  }
}


export function timeline(data) {
  return {
    title: 'Timeline',
    content: [
      [
        {
          year: 2016,
          date: 'December',
          title: '12.15',
          subTitle: 'Kohai written application open'
        }
      ],
      [
        {
          year: 2017,
          date: 'March',
          title: '3.31',
          subTitle: 'Kohai interviews begin'
        },
        {
          date: '',
          title: '',
          subTitle: 'Kohai interviews'
        }
      ],
      [
        {
          date: 'April',
          title: '4.31',
          subTitle: 'Kohai groups announced (rolling)'
        },
        {
          date: 'July',
          title: '7.9 - 7.22',
          subTitle: 'Camps in France and Romania'
        }
      ]
    ],
    contentLarge: [
      {
        date: data['timeline-g'],
        content: [
          {
            title: data['timeline-g-title'],
            subTitle: data['timeline-g-sub']
          }
        ]
      },
      {
        date: data['timeline-h'],
        content: [
          {
            title: data['timeline-h-title-a'],
            subTitle: data['timeline-h-sub-a']
          },
          {
            title: data['timeline-h-title-b'],
            subTitle: data['timeline-h-sub-b']
          },
          {
            title: data['timeline-h-title-c'],
            subTitle: data['timeline-h-sub-c']
          }
        ]
      },
      {
        date: data['timeline-i'],
        content: [
          {
            title: data['timeline-i-title-a'],
            subTitle: data['timeline-i-sub-a']
          },
          {
            title: data['timeline-i-title-b'],
            subTitle: data['timeline-i-sub-b']
          }
        ]
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/modules/kohai.js